/**
 * @typedef {Object} Tag
 * @property {string=} activityId
 * @property {string=} date
 * @property {string=} id
 * @property {string=} label
 * @property {string=} value
 */

/**
 * @typedef {Object} Activity
 * @property {string=} id
 * @property {string=} date
 * @property {string=} username
 * @property {string=} displayname
 * @property {string=} username_other
 * @property {string=} displayname_other
 * @property {number=} type
 * @property {string=} meta_title
 * @property {string=} meta_count
 * @property {Tag[]=} tags
 */

/**
 * @typedef {Object} ActivityService
 * @property {function(): angular.IPromise<Activity[]>} get
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @returns {ActivityService}
 */
function bahabotActivityFactory($resource) {
    const Activity = $resource('/api/protected/activities/', {}, {
        get: { method: 'GET' },
    });

    const self = {};

    self.filters = {
        type: "",
        text: "",
        dateFrom: "",
        dateTo: "",
        cursor: "",
    }

    self.totalCount = 0;

    self.lastFilters = null;

    self.data = null;

    self.loading = false;
    self.loadingMore = false;

    self.validateDates = () => {
        let from = self.filters.dateFrom ? new Date(self.filters.dateFrom) : null;
        let to = self.filters.dateTo ? new Date(self.filters.dateTo) : null;

        if (from && isNaN(from.getTime())) {
            from = null;
        }
        if (to && isNaN(to.getTime())) {
            to = null;
        }
    
        if (from && to && from > to) {
            const temp = from;
            from = to;
            to = temp;
        }
    
        self.filters.dateFrom = from ? from.toISOString() : "";
        self.filters.dateTo = to ? to.toISOString() : "";
    };

    self.get = () => {
        self.validateDates();
        self.loading = true;
        return Activity
            .get(self.filters)
            .$promise
            .then(res => {
                self.data = res.data;
                self.lastFilters = { ...self.filters };
                self.lastFilters.cursor = res.data.pageInfo.endCursor;
                self.totalCount = res.data.pageInfo.totalCount;
                return res.data;
            })
            .finally(() => {
                self.loading = false;
            });
    };

    self.next = () => {
        self.loadingMore = true;
        return Activity
            .get(self.lastFilters)
            .$promise
            .then(res => {
                self.data.items = [...self.data.items, ...res.data.items];
                self.data.pageInfo = res.data.pageInfo;
                self.lastFilters.cursor = res.data.pageInfo.endCursor;
                return self.data;
            })
            .finally(() => {
                self.loadingMore = false;
            });
    }

    self.resetFilters = () => {
        self.filters.type = "";
        self.filters.text = "";
        self.filters.dateFrom = "";
        self.filters.dateTo = "";
        self.filters.cursor = "";
        return self;
    };

    return self;
}

mod.factory('ActivityService', ["$resource", bahabotActivityFactory]);
